




















































































































import {
  computed, defineComponent,
  nextTick,
  onMounted,
  onUnmounted,
  ref, useContext,
  useRouter, watch
} from "@nuxtjs/composition-api";

import { SfLoader } from "@storefront-ui/vue";
import { storeToRefs } from "pinia";
import JetUiButton from "~/components/JetUi/atoms/JetUiButton/JetUiButton.vue";
import Tooltip from "~/components/JetUi/atoms/Tooltip/Tooltip.vue";
import AddressSummary from "~/components/JetUi/organisms/Checkout/AddressSummary.vue";
import CartSummary from "~/components/JetUi/organisms/Checkout/CartSummary.vue";
import ClientSummary from "~/components/JetUi/organisms/Checkout/ClientSummary.vue";
import PaymentMethods from "~/components/JetUi/organisms/Checkout/PaymentMethods.vue";
import { useAbandonedCart, useMakeOrder, usePaymentCard, usePaymentProvider, useUser } from "~/composables";
import useCart from "~/modules/checkout/composables/useCart";
import Shipping from "~/modules/checkout/pages/Checkout/JetCheckout/Shipping.vue";
import { useCheckoutStore } from "~/stores/checkout";
import { useThankYouStore } from "~/stores/thankyou";
import SpaceLoadingScreen from "./SpaceLoadingScreen.vue";

const phrases = [
  'Olá {{ username }}! Tá quase lá! Sua compra está pronta para ser concluída!',
  'Oi {{ username }}! Confirme seu pedido e aproveite, sua compra está a um clique!',
  'Olá {{ username }}! Garanta o que escolheu, finalize sua compra com segurança!',
  'Oi {{ username }}! Não perca a chance, finalize e receba seu pedido rapidamente!',
  'Olá {{ username }}! Seu carrinho está ansioso para virar seu, finalize já!',
  'Oi {{ username }}! É tudo seu, finalize agora e aproveite a facilidade!',
  'Olá {{ username }}! Tá pronto para concluir? Finalize sua compra sem complicação!',
  'Oi {{ username }}! O próximo passo é simples: finalize sua compra agora!',
  'Olá {{ username }}! Seu pedido está te esperando. Conclua e aproveite!',
  'Oi {{ username }}! Aproveite essa chance de levar o que escolheu para casa!',
  'Olá {{ username }}! Está tudo pronto, só falta você finalizar sua compra!',
  'Oi {{ username }}! Vamos fechar o pedido? Finalize e receba com agilidade!',
  'Olá {{ username }}! Seu carrinho não vê a hora de ser seu. Finalize agora!',
  'Oi {{ username }}! Tudo pronto! Finalize sua compra com um clique!',
  'Olá {{ username }}! Tá fácil e rápido: finalize sua compra e aproveite já!',
  'Oi {{ username }}! Estamos quase lá! Finalize e garanta o seu pedido!',
  'Olá {{ username }}! Aproveite essa etapa final. Conclua sua compra em instantes!',
  'Oi {{ username }}! Tá na hora de fechar com chave de ouro. Finalize agora!',
  'Olá {{ username }}! Sua compra está a um clique. Finalize e aproveite sem demora!',
];

export default defineComponent({
  name: 'Checkout',
  components: {
    CartSummary,
    Shipping,
    SfLoader,
    ClientSummary,
    PaymentMethods,
    AddressSummary,
    JetUiButton,
    Tooltip,
    SpaceLoadingScreen,
  },
  setup() {
    const { load, cart, createEmptyCart } = useCart();
    const { resetPaymentCardData, selectedPaymentCard, selectedInstallment } = usePaymentCard();
    const { deleteAbandonedCart } = useAbandonedCart();
    const { app } = useContext();
    const router = useRouter();
    const blockScreen = ref(false);
    const checkoutStore = useCheckoutStore();
    const thankYouStore = useThankYouStore();
    const { isThankYou } = storeToRefs(thankYouStore);
    const showProducts = ref(true);
    const { selectedPaymentMethod, loading, clientSummaryHeight } = storeToRefs(checkoutStore);

    const { isAuthenticated, user } = useUser();
    const { processPayment } = usePaymentProvider();
    const { make } = useMakeOrder();
    const customerSummary = ref(null);
    const username = computed(() => {
      const name = user.value?.firstname || '';
      return name.split(' ')[0];
    });
    const randomPhrase = ref('');

    const randomIndex = Math.floor(Math.random() * phrases.length);
    randomPhrase.value = phrases[randomIndex].replace('{{ username }}', username.value || '').replace(', !', '!');

    const changeTitle = () => {
      const atentionPhrases = [
        'Oi {{ username }}! Não deixe seu carrinho esperando, finalize sua compra agora mesmo!',
        'Olá {{ username }}! Tá quase lá! Sua compra está pronta para ser concluída!',
        'Oi {{ username }}! Confirme seu pedido e aproveite, sua compra está a um clique!',
        'Olá {{ username }}! Garanta o que escolheu, finalize sua compra com segurança!',
        'Oi {{ username }}! Não perca a chance, finalize e receba seu pedido rapidamente!',
        'Olá {{ username }}! Seu carrinho está ansioso para virar seu, finalize já!',
        'Oi {{ username }}! É tudo seu, finalize agora e aproveite a facilidade!',
        'Olá {{ username }}! Tá pronto para concluir? Finalize sua compra sem complicação!',
        'Oi {{ username }}! O próximo passo é simples: finalize sua compra agora!',
        'Olá {{ username }}! Seu pedido está te esperando. Conclua e aproveite!',
        'Oi {{ username }}! Aproveite essa chance de levar o que escolheu para casa!',
        'Olá {{ username }}! Está tudo pronto, só falta você finalizar sua compra!',
        'Oi {{ username }}! Vamos fechar o pedido? Finalize e receba com agilidade!',
        'Olá {{ username }}! Seu carrinho não vê a hora de ser seu. Finalize agora!',
        'Oi {{ username }}! Tudo pronto! Finalize sua compra com um clique!',
        'Olá {{ username }}! Tá fácil e rápido: finalize sua compra e aproveite já!',
        'Oi {{ username }}! Estamos quase lá! Finalize e garanta o seu pedido!',
        'Olá {{ username }}! Aproveite essa etapa final. Conclua sua compra em instantes!',
        'Oi {{ username }}! Tá na hora de fechar com chave de ouro. Finalize agora!',
        'Olá {{ username }}! Sua compra está a um clique. Finalize e aproveite sem demora!',
      ];
      const randomIndex = Math.floor(Math.random() * atentionPhrases.length);
      document.title = atentionPhrases[randomIndex].replace('{{ username }}', username.value || '').replace(', !', '!');
    };

    const changePhrase = () => {
      const randomIndex = Math.floor(Math.random() * phrases.length);
      randomPhrase.value = phrases[randomIndex].replace('{{ username }}', username.value || '').replace(', !', '!');
    };

    onMounted(async () => {
      await load();
      if (user.value) {
        const randomIndex = Math.floor(Math.random() * phrases.length);
        randomPhrase.value = phrases[randomIndex].replace('{{ username }}', username.value || '').replace(', !', '!');
      }
      resetPaymentCardData();
      if (isAuthenticated.value) {
        checkoutStore.resetState(['addresses', 'currentShippingAddressId', 'currentBillingAddressId', 'selectedShippingMethod']);
      } else {
        checkoutStore.resetState();
      }
      window.addEventListener('blur', changeTitle);
      window.addEventListener('pagehide', changeTitle);
      blockScreen.value = false;
      windowWidth.value = window.innerWidth;

      await nextTick();
      if (customerSummary.value) {
        clientSummaryHeight.value = customerSummary.value.offsetHeight;
      }
    });

    onUnmounted(() => {
      window.removeEventListener('blur', changeTitle);
      window.removeEventListener('pagehide', changeTitle);
    });

    watch(cart, async (newCart) => {
      if (newCart) {
        await nextTick();
        if (customerSummary.value) {
          clientSummaryHeight.value = customerSummary.value.offsetHeight;
        }
      }
    });

    const windowWidth = ref(0);

    const placeOrder = async () => {
      blockScreen.value = true;
      const orderNumber = ref(null);
      const response = await make(selectedPaymentMethod?.value);
      const price = cart?.value?.prices?.grand_total.value;
      const cartCopy = cart.value;

      let selectedCardObject = null;
      if (selectedPaymentMethod?.value === 'jetcred') {
        selectedCardObject = {
          card: selectedPaymentCard.value,
          installment: selectedInstallment.value,
        };
      }
      orderNumber.value = response.message.data?.placeOrder?.order?.order_number

      if (!orderNumber.value) {
        const response = await make(selectedPaymentMethod?.value)
        orderNumber.value = response.message.data?.placeOrder?.order?.order_number
        if (!orderNumber.value) {
          window.location.reload();
        }

      }

      const payment = await processPayment(selectedPaymentMethod?.value, price, user, orderNumber.value);
    
      await deleteAbandonedCart(cart.value.id);
      app.$vsf.$magento.config.state.removeCartId();
      await load();
      let pixData = null;
      if (payment?.txid) {
        pixData = { txid: payment?.txid, price: payment?.valor.original };
      }
      createEmptyCart();
      thankYouStore.onPaymentSuccess({
        orderNumber,
        pixData,
        slipBody: selectedPaymentMethod?.value === 'jetcred' ? null : payment,
        selectedCardObject,
        price: price.toString(),
        cart: cartCopy,
        success: payment? true : false,
      });
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      blockScreen.value = false;
      await router.push(app.localeRoute({ name: 'checkout-success' }));
    };

    const showBanner = computed(() => (selectedPaymentMethod.value !== 'jetcred') || (selectedPaymentMethod.value === 'jetcred' && selectedPaymentCard.value && selectedInstallment.value));

    const isCompleted = computed(() => isAuthenticated && checkoutStore.isShippingCompleted && checkoutStore.isPaymentCompleted);

    return {
      placeOrder,
      loading,
      blockScreen,
      isAuthenticated,
      randomPhrase,
      isThankYou,
      username,
      selectedPaymentMethod,
      selectedPaymentCard,
      showBanner,
      isCompleted,
      isShippingCompleted: checkoutStore.isShippingCompleted,
      isPaymentCompleted: checkoutStore.isPaymentCompleted,
      windowWidth,
      customerSummary,
      changePhrase,
      showProducts,
    };
  },
  head() {
    return {
      title: this.$t('Checkout').toString(),
      script: [
        {
          hid: 'gtag-js',
          async: true,
          src: 'https://www.googletagmanager.com/gtag/js?id=AW-11127232168',
          defer: true,
        },
        {
          hid: 'gtag-config',
          innerHTML: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-11127232168');
        `,
          type: 'text/javascript',
          charset: 'utf-8',
          defer: true,
        },
      ],
      __dangerouslyDisableSanitizersByTagID: {
        'gtag-config': ['innerHTML'],
      },
    };
  },
});
